const PDF_LAMBDA_URI = process.env.PDF_LAMBDA_URI;
const PDF_LAMBDA_API_KEY = process.env.PDF_LAMBDA_API_KEY;
const PDF_LAMBDA_STAGE = process.env.PDF_LAMBDA_STAGE;

export async function generatePdf(
  data: any,
  endpoint: string,
  forDownload: boolean = false,
  filename: string = "output.pdf"
) {
  try {
    const event_data = { data };

    const response = await fetch(PDF_LAMBDA_URI + PDF_LAMBDA_STAGE + endpoint, {
      body: JSON.stringify(event_data),
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": PDF_LAMBDA_API_KEY
      },
      method: "POST"
    });

    if (!response.ok) {
      throw new Error("Failed to generate PDF");
    }

    const jsonResponse = await response.json();
    const base64String = jsonResponse.data;

    const binaryString = atob(base64String);
    const binaryData = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([binaryData], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    if (forDownload) {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(url, "_blank");
    }

    window.addEventListener("unload", () => {
      window.URL.revokeObjectURL(url);
    });
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}
